import styled from 'styled-components'

export const Options = styled.div`
  button {
    float: right;
    padding: 0 8px;
    color: #4c4c4c !important;
    border-radius: 8px;
    background-color: #f0f0f0 !important;
    margin-left: 8px;
    svg {
      transition: 200ms;
    }
    &:hover > svg {
      opacity: 0.5;
    }
  }
  button + button {
    margin-left: 0;
  }
`

export const DragAndDrop = styled.div`
  button {
    padding: 0 13px;
    color: #757575 !important;
    svg {
      transition: 200ms;
    }
    &:hover > svg {
      opacity: 0.5;
    }
  }
`

export const AddCourse = styled.div`
  button {
    color: #2684ff;
    height: 40px;
    margin-top: 8px;
    font-weight: 700;
    svg {
      margin-right: 8px;
    }
  }
`

export const Column = styled.div`
  svg {
    margin-left: 4px;
    color: #757575;
  }
`

export const TooltipTitle = styled.div`
  text-align: center;
  font-family: 'Roboto';
  a {
    margin-left: 5px;
    color: #bfbfbf;
    text-decoration: underline !important;
  }
`

export const TableHeader = styled.div`
  margin-top: 16px;
  font-size: 12px;
  font-weight: bold;
  color: #808080;
  .ant-col {
    padding: 10px 0;
    padding-right: 13px;
    border-bottom: 1px solid #d9d9d9;
  }
`

export const TableBody = styled.div`
  font-size: 14px;
  color: #363636;
  .ant-col {
    padding: 10px 0;
    padding-right: 13px;
    border-bottom: 1px solid #d9d9d9;
    line-height: 30px;
  }
`

export const TotalCourses = styled.div`
  margin-top: 16px;
  span {
    background-color: #f5f5f5;
    border-radius: 8px;
    padding: 4px 6px;
    color: #363636;
    font-size: 14px;
    svg {
      height: 12px;
      margin-right: 6px;
      margin-bottom: 1px;
    }
  }
`

export const EmptyStateWrapper = styled.div`
  padding-top: 24px;
`

export const CourseName = styled.div`
  padding-left: 20px;
  height: 32px;
  padding-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  svg {
    position: absolute;
    color: #d48806;
    font-size: 12px;
    margin-top: 8px;
    margin-left: -19px;
  }
`
